<script setup lang="ts">
  import IconInfo from "@/icons/IconInfo.vue";
  import {useCartStore} from "@/stores/cartStore";
  import DiscountProvideEmail from "@/components/DiscountProvideEmail.vue";
  import DiscountSubmit from "@/components/DiscountSubmit.vue";
  import IconTagRemove from "@/icons/IconTagRemove.vue";
  const props = defineProps(['lineItems']);
  const cartStore = useCartStore();

  const handleRemoveCode = () => {
    if(!cartStore.submitting) {
      cartStore.removeDiscountCode();
    }
  }
</script>
<template>
  <template v-if="!cartStore.isLineItemsFilled">
    <div class="discount-box__requirements">
      <div class="discount-box__pre-requirements-icon">
        <IconInfo aria-hidden="true" width="50" height="50"/>
      </div>
      <span class="discount-box__pre-requirements-text">Please confirm shipping information to enter the promo code</span>
    </div>
  </template>

  <DiscountProvideEmail />

  <DiscountSubmit v-if="cartStore.discountData.error_code !== 'opc_1'"/>

  <p class="discount-box__invalid-text" v-show="cartStore.discountData.success === false && cartStore.discountData.error_code === 'opc_3'">{{cartStore.discountData.message}}</p>
  <p class="discount-box__invalid-text" v-show="cartStore.discountData.error_code === 'opc_4'">Error: Code is invalid or does not apply to items currently in cart.</p>
  <p class="discount-box__invalid-text" v-show="cartStore.discountData.error_code === 'opc_2'">Error: This discount coupon was already applied.</p>

  <div class="discount-tags" data-discount-tags="discount-tags">
    <template v-if="cartStore.discountData.code && cartStore.discountData.success === true">
      <div class="discount-tags__tag">
        <svg xmlns="http://www.w3.org/2000/svg" class="discount-tags__icon-filled" viewBox="0 0 18 18">
          <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path>
          <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path>
        </svg>
        {{ cartStore.discountData.code }}
        <button type="button" class="discount-tags__remove" @click="handleRemoveCode">
          <IconTagRemove />
        </button>
      </div>
    </template>
  </div>
</template>